// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3v1je","colMin":"styles_colMin__2XW6v"};